
export enum SectionVisible {
  Classlink = 'classlink',
  Course = 'courses',
  Group = 'groups',
  Direct = 'direct'
}
